import React from 'react';
import { useData } from '../context/DataContext';

const Devis = () => {
  const { devis } = useData();

  return (
    <div>
      <h2>📄 Devis</h2>
      <div className="cout-summary">
        <div className="cout-summary-item">
          <span>Total devis</span>
          <strong>{devis.length}</strong>
        </div>
      </div>
      <div className="table-scroll">
        <table className="data-table" role="table">
        <thead>
          <tr>
            <th>N° devis</th>
            <th>Date</th>
            <th>Client</th>
            <th>Chantier</th>
            <th>Montant HT</th>
            <th>TVA</th>
            <th>TTC</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {devis.map((d, i) => (
            <tr key={i}>
              <td>{d.numero}</td>
              <td>{d.date}</td>
              <td>{d.client}</td>
              <td>{d.chantier}</td>
              <td>{d.montantHT.toFixed(2)} €</td>
              <td>{d.tva.toFixed(2)} €</td>
              <td>{d.montantTTC.toFixed(2)} €</td>
              <td>
                <span className={`badge badge-${d.statut.toLowerCase().replace(' ', '-')}`}>
                  {d.statut}
                </span>
              </td>
            </tr>
          ))}
          {devis.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center', color: 'var(--color-text-secondary)', padding: '2rem' }}>
                Aucun devis. Importez des données depuis l'onglet "Tableau de bord".
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default Devis;